import PropTypes from 'prop-types';
import { useState } from 'react';
import { downloadPdf } from '@shared/helpers';
import Check from '@assets/icons/check-green.svg';
import { useRouter } from 'next/router';
import signatureId from '@shared/helpers/signatureId';
import DesktopRow from './DesktopRow';
import MobileRow from './MobileRow';
import { DROPDOWN_ITEMS, DROPDOWN_VALUES } from './constants';

const DocTableRow = ({ item, currentPage, isSelected, onSelect, isMobile }) => {
  const router = useRouter();
  const [updatedItems, setUpdatedItems] = useState(DROPDOWN_ITEMS);

  const updateIcon = () => {
    setUpdatedItems(
      DROPDOWN_ITEMS.map(el =>
        el.value === DROPDOWN_VALUES.SHARE
          ? { value: 'Copied', icon: <Check />, disabled: true }
          : el,
      ),
    );

    setTimeout(() => {
      setUpdatedItems(DROPDOWN_ITEMS);
    }, 1000);
  };

  const handleItemClick = selected => {
    switch (selected.value) {
      case DROPDOWN_VALUES.SHARE:
        updateIcon();
        navigator.clipboard.writeText(item?.signed_doc_url);
        break;
      case DROPDOWN_VALUES.DETAILS:
        router.push(`doc-viewer/${signatureId(item)}`);
        break;
      default:
        break;
    }
  };

  const onDownload = event => {
    event.stopPropagation();
    downloadPdf({ pdfLink: item?.signed_doc_url, filename: item?.form_id });
  };

  return isMobile ? (
    <MobileRow
      item={item}
      rowCheckbox={signatureId(item)}
      onDownload={onDownload}
      handleItemClick={handleItemClick}
      dropdownItems={updatedItems}
      isSelected={isSelected}
      onSelect={onSelect}
    />
  ) : (
    <DesktopRow
      item={item}
      rowCheckbox={signatureId(item)}
      onDownload={onDownload}
      handleItemClick={handleItemClick}
      dropdownItems={updatedItems}
      isSelected={isSelected}
      onSelect={onSelect}
    />
  );
};

DocTableRow.propTypes = {
  item: PropTypes.shape({
    user_id: PropTypes.string,
    date: PropTypes.string,
    form_id: PropTypes.string,
    signature_type: PropTypes.string,
    signed_doc_url: PropTypes.string,
  }),
  currentPage: PropTypes.number,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  isMobile: PropTypes.bool,
};

export default DocTableRow;
